"use strict";

/* eslint-disable no-undef, no-restricted-globals, func-names */
jQuery(document).ready($ => {
  var $sncForm = $('.snc-media_enbed_form');

  // Get Code From PHP
  $sncForm.ajaxForm({
    success: response => {
      var data = JSON.parse(response);
      var win = window.dialogArguments || opener || parent || top;
      win.send_to_editor(data.shortcode);
    }
  });
});